import React from 'react';
import PropTypes from 'prop-types';

import { Typography } from '@mui/material';

import { BBSpinner, Flex } from '../../components';

const CircularLoading = ({ error = false, size = 'md' }) => (
  <Flex
    sx={{
      height: '100vh',
      width: '100%',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 1,
    }}
  >
    {!error ? (
      <BBSpinner size={size} />
    ) : (
      <Flex.V
        sx={{
          justifyContent: 'center',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <Typography variant="h2">Error loading page</Typography>
      </Flex.V>
    )}
  </Flex>
);

CircularLoading.propTypes = {
  error: PropTypes.bool,
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
};

export default CircularLoading;
